const CANDIDATE_STATUS = {
  CANDIDATE: 'candidate',
  IN_PROGRESS: 'in-progress',
  OVERDUE: 'overdue',
  COMPLETED: 'completed',
  CANCELED: 'canceled',
  DELETED: 'deleted',
};

export const CC_STATUS = {
  CANDIDATE: 'candidate',
  SUBMITTED: 'submitted',
  IN_PROGRESS: 'in-progress',
  COMPLETED: 'completed',
  CANCELED: 'canceled',
};

const REFEREE_STATUS = {
  IN_PROGRESS: 'in-progress',
  OVERDUE: 'overdue',
  COMPLETED: 'completed',
  CANCELED: 'canceled',
};

const CC_STATUS_ICON = {
  PENDING: 'pending',
  UNVERIFIED: 'unverified',
  IN_PROGRESS: 'in-progress',
  SUBMITTED: 'submitted',
  COMPLETED: 'completed',
  PASSED: 'passed',
  VERIFIED: 'verified',
  COMPLETED_WITH_RESULT: 'completed-with-result',
  CANCELED: 'canceled',
  DELETED: 'deleted',
  OVERDUE: 'overdue',
  CANDIDATE: 'candidate',
  DECLINED: 'declined',
};

export const CC_STATUS_ICON_DISPLAY = {
  [CC_STATUS_ICON.PENDING]: { title: 'Pending', color: 'warning' },
  [CC_STATUS_ICON.UNVERIFIED]: { title: 'Unverified', color: 'warning' },
  [CC_STATUS_ICON.IN_PROGRESS]: { title: 'In Progress', color: 'info' },
  [CC_STATUS_ICON.SUBMITTED]: { title: 'Submitted', color: 'info' },
  [CC_STATUS_ICON.COMPLETED]: { title: 'Completed', color: 'success' },
  [CC_STATUS_ICON.PASSED]: { title: 'Passed', color: 'success' },
  [CC_STATUS_ICON.VERIFIED]: { title: 'Verified', color: 'success' },
  [CC_STATUS_ICON.COMPLETED_WITH_RESULT]: { title: 'Completed with Result', color: 'success' },
  [CC_STATUS_ICON.CANCELED]: { title: 'Canceled', color: 'neutral-light' },
  [CC_STATUS_ICON.DELETED]: { title: 'Deleted', color: 'error' },
  [CC_STATUS_ICON.OVERDUE]: { title: 'Overdue', color: 'error' },
  [CC_STATUS_ICON.CANDIDATE]: { title: 'Candidate', color: 'warningLight' },
  [CC_STATUS_ICON.DECLINED]: { title: 'Declined', color: 'error' },
};

export const CANDIDATE_STATUS_DISPLAY = {
  [CANDIDATE_STATUS.CANDIDATE]: { title: 'Candidate', color: 'neutral' },
  [CANDIDATE_STATUS.IN_PROGRESS]: { title: 'In Progress', color: 'warning' },
  [CANDIDATE_STATUS.OVERDUE]: { title: 'Overdue', color: 'error' },
  [CANDIDATE_STATUS.COMPLETED]: { title: 'Completed', color: 'success' },
  [CANDIDATE_STATUS.CANCELED]: { title: 'Canceled', color: 'error' },
  [CANDIDATE_STATUS.DELETED]: { title: 'Deleted', color: 'error' },
};

export const CC_STATUS_DISPLAY = {
  [CC_STATUS.CANDIDATE]: { title: 'Candidate', color: 'neutral' },
  [CC_STATUS.SUBMITTED]: { title: 'Submitted', color: 'continue' },
  [CC_STATUS.IN_PROGRESS]: { title: 'In Progress', color: 'warning' },
  [CC_STATUS.COMPLETED]: { title: 'Completed', color: 'success' },
  [CC_STATUS.CANCELED]: { title: 'Canceled', color: 'error' },
};

export const REFEREE_STATUS_DISPLAY = {
  [REFEREE_STATUS.IN_PROGRESS]: { title: 'In Progress', color: 'warning' },
  [REFEREE_STATUS.OVERDUE]: { title: 'Overdue', color: 'error' },
  [REFEREE_STATUS.COMPLETED]: { title: 'Completed', color: 'success' },
  [REFEREE_STATUS.CANCELED]: { title: 'Canceled', color: 'error' },
};
